import React from "react";
import ClientAppSidebar from "../../../../components/ClientAppSidebar";
import {
  LastMonthExpenseSection,
  ExpenseThisMonthSection,
  KeyMetricsExpenseSection,
  TwelveMonthExpenseTrendSection,
  ExpenseBreakdownSection,
  RecentExpenseActivitySection,
} from "../components/expense_components";
import { useExpenseBootstrap } from "../hooks/useExpenseBootstrap";

/**
 * Expense page: one bootstrap request for core metrics; AI insights still load per section.
 */
export default function ExpensePage() {
  useExpenseBootstrap();

  return (
    <div className="flex w-full items-start h-screen">
      <ClientAppSidebar />
      <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 self-stretch bg-default-background overflow-y-auto">
        <div className="container max-w-none flex w-full min-w-0 grow shrink-0 basis-0 items-start gap-8 bg-neutral-50 py-12 overflow-auto">
          <div className="flex min-w-0 grow shrink-0 basis-0 flex-col items-start gap-8 w-full max-w-full">
            <div className="flex w-full flex-col items-start gap-4">
              <div className="flex w-full items-center justify-between">
                <span className="text-heading-1 font-heading-1 text-default-font">
                  Expense
                </span>
              </div>
            </div>
            <ExpenseThisMonthSection />
            <LastMonthExpenseSection />

            <KeyMetricsExpenseSection />
            <TwelveMonthExpenseTrendSection />
            <ExpenseBreakdownSection />
            {/* <UpcomingBillsSection /> */}
            <RecentExpenseActivitySection />
          </div>
        </div>
      </div>
    </div>
  );
}
